const getNumberSeparators = (locale) => {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6)

    return {
        decimal: parts.find(({ type }) => type === 'decimal')?.value ?? '.',
        group: parts.find(({ type }) => type === 'group')?.value ?? '',
    }
}

export const createLocaleNumberFormatters = (locale, currency = 'DKK') => {
    const numberFormatter = new Intl.NumberFormat(locale, {
        maximumFractionDigits: 0,
    })
    const currencyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        maximumFractionDigits: 0,
        currency,
    })

    return {
        formatNumber: numberFormatter.format,
        formatCurrency: currencyFormatter.format,
    }
}

export const createLocaleNumberInputFormat = (locale) => {
    const { group } = getNumberSeparators(locale)

    return {
        mask: Number,
        normalizeZeros: false,
        min: 0,
        max: Number.MAX_SAFE_INTEGER,
        thousandsSeparator: group,
        scale: 0,
    }
}

export const parseLocaleNumber = (value, locale) => {
    const { decimal, group } = getNumberSeparators(locale)
    let normalizedValue = String(value ?? '').trim()

    if (group) {
        normalizedValue = normalizedValue.split(group).join('')
    }

    if (decimal !== '.') {
        normalizedValue = normalizedValue.replace(decimal, '.')
    }

    return Number(normalizedValue)
}